import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import '../../assets/css/sign-in.css';
import '../../assets/css/font-icons.css';

import { handleAuthentication, loginWithMicrosoft } from '../../actions/AuthedActions';
import Login from './index';

const mapStateToProps = (state) => ({
    isLoggedIn: state.authed.accessToken,
    errorMsg: state.authed.authErrMsg,
    microsoftAuthErr: state.authed.microsoftAuthErr,
    authCancelled: state.authed.authCancelled || false,
});

const mapDispatchToProps = (dispatch) => ({
    handleAuth: (h) => dispatch(handleAuthentication(h)),
    push: (f) => dispatch(push(f)),
    loginWithMicrosoft: (f) => dispatch(loginWithMicrosoft(f)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
